export const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:3000';
export const APP_URL = process.env.REACT_APP_URL || 'https://referral.tothenew.com'
